import { render, staticRenderFns } from "./OFormWrapper.vue?vue&type=template&id=11801822&scoped=true&"
import script from "./OFormWrapper.vue?vue&type=script&lang=js&"
export * from "./OFormWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11801822",
  null
  
)

export default component.exports